import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { OpportunityForm, OpportunityFormType } from './OpportunityForm'
import { getOpportunityById, updateOpportunity } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useParams } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Opportunities',
    path: '/opportunities'
  },
  {
    label: 'Edit',
    isCurrentPage: true
  }
]

export const EditOpportunity = () => {
  const { opportunityId } = useParams()
  const { createToast } = useAppContext()
  const [opportunity, setOpportunity] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const load = async () => {
    try {
      const row = await getOpportunityById(opportunityId)
      setOpportunity({
        ...row,
        salesUser: { id: row.salesUserId, name: row.salesUserName },
        customer: { id: row.customerId, name: row.customerCompany },
        signType: row.signType ? JSON.parse(row.signType) : [],
        campaignId: row.campaignId ? JSON.parse(row.campaignId) : []
      })
    } catch (err) {
      createToast('error', 'Error', err.response.data)
    }
  }

  useEffect(() => {
    load()
  }, [])

  const handleEdit = async (form) => {
    setIsSubmitting(true)

    try {
      const row = await updateOpportunity(opportunityId, {
        salesUserId: form.salesUser?.id || 0,
        name: form.name,
        company: form.customer?.customerCompany || '',
        customerId: form.customer?.id || 0,
        email: form.email,
        phone: form.phone,
        amount: form.amount,
        closingDate: form.closingDate,
        stage: form.stage,
        signType: JSON.stringify(form.signType),
        probability: form.probability,
        address: form.address,
        state: form.state,
        zip: form.zip,
        campaignId: JSON.stringify(form.campaignId),
        description: form.description
      })
      if (row) {
        load()
        createToast('success', 'Opportunity updated.')
      } else {
        createToast('error', 'Failed to update.')
      }
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Edit Opportunity</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <OpportunityForm
              type={OpportunityFormType.Edit}
              onSubmit={handleEdit}
              isSubmitting={isSubmitting}
              initialForm={opportunity}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
